import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (id) {
  const { isRequestSuccessed, exec, rst } = useRequest({
    name: 'DELETE_STD_CRAFT',
    url: '',
    method: 'DELETE',
  });

  useEffect(() => {
    if (id) exec(`/api/produce-crafts/${id}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return [rst, isRequestSuccessed];
});
